import { render, staticRenderFns } from "./teacherPassDialog.vue?vue&type=template&id=335028e4"
import script from "./teacherPassDialog.vue?vue&type=script&lang=js"
export * from "./teacherPassDialog.vue?vue&type=script&lang=js"
import style0 from "./teacherPassDialog.vue?vue&type=style&index=0&id=335028e4&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports